<template>
  <div class="custom-table-responsive table-responsive">
    <table class="table table-bordered table table-journals not-last-td">
      <thead>
        <tr class="cusmtom-thead-color">
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label fixed-column-custom-th"
          >
            <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content">
                <span>{{ $t('labor.cpa_capture_tooltip') }}</span>
              </div>
              <em class="fa fa-info-circle" aria-hidden="true"></em>
            </el-tooltip>
            <br />
            <span>{{ $t('common_words.specific_area') }}</span>
          </th>
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label fixed-column-activity-th"
          >
            {{ $t('common_words.activity') }} *
          </th>
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label fixed-column-lot-th"
          >
            {{ $t('common_words.allotment') }} *
          </th>
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label fixed-column-covered-area-th"
          >
            {{ $t('common_words.area_total_ha') }}
          </th>
          <th
            scope="col"
            :colspan="weekList.length"
            class="text-center p-3 custom-header-label"
          >
            {{ $t('common_words.week') }}
          </th>
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label fixed-column-operations-th"
          >
            {{ $t('common_words.actions') }}
          </th>
        </tr>
        <tr class="cusmtom-thead-color">
          <th
            v-for="week in weekList"
            :key="week"
            scope="col"
            class="text-center p-3 custom-header-label"
          >
            {{ week }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(_, index) in form.nCatchs" :key="index">
          <td
            class="text-center fixed-column-custom-td"
            style="min-width: 110px"
          >
            <el-checkbox
              :value="form.custom[index]"
              @change="handleCustomSelection(index)"
            ></el-checkbox>
          </td>
          <td
            class="text-center fixed-column-activity-td"
            style="min-width: 250px"
          >
            <select-component
              :dataOptions="activities"
              :initialSelection="form.activity[index]"
              :isMultiple="false"
              :indexSelect="index"
              :requireClass="'required-activity'"
              @onChange="handleInputChange"
              modelName="activity"
            />
          </td>
          <td class="text-center fixed-column-lot-td" style="min-width: 200px">
            <select-component
              :dataOptions="form.custom[index] ? farmLots : farmLotsMultiple"
              :isMultiple="!form.custom[index]"
              :initialSelection="form.lot[index]"
              :indexSelect="index"
              :requireClass="`required-lot_${index}`"
              @onChange="handleInputChange"
              modelName="lot"
            />
          </td>
          <td
            class="text-center fixed-column-covered-area-td"
            style="min-width: 150px"
          >
            <fg-input
              type="number"
              step="0.1"
              class="mx-3"
              v-model.number="form.covered_area[index]"
              :disabled="isCoveredAreaDisabled(index)"
              :name="`common_words.area_total_ha_${index}`"
              v-validate="modelValidations.area(index)"
              :error="
                getFieldErrorByIndex('common_words.area_total_ha', true, index)
              "
            />
          </td>
          <td
            v-for="(week, indexcolumn) in weekList"
            :key="indexcolumn"
            class="text-center"
            style="min-width: 100px"
          >
            <el-checkbox
              :value="form.weeks[index] && form.weeks[index].includes(week)"
              :disabled="isPastWeekDisabled(week)"
              @change="handleWeekSelection(index, week)"
            ></el-checkbox>
          </td>
          <td
            class="text-center fixed-column-operations-td"
            style="min-width: 110px"
          >
            <div class="d-flex justify-content-center mt-3">
              <a
                v-if="form.weeks[index] && form.weeks[index].length > 0"
                v-tooltip.top-center="$t('common_words.clear_checks')"
                class="btn-warning btn-simple btn-link custom-margin-actions"
                @click="clearWeekSelection(index)"
              >
                <em class="fa fa-history custom-size-fa-actions"></em>
              </a>
              <a
                v-tooltip.top-center="$t('common_words.edit')"
                class="btn-success btn-simple btn-link custom-margin-actions"
                @click="addScheduleRow()"
              >
                <em class="fa fa-plus custom-size-fa-actions"></em>
              </a>
              <a
                v-if="form.nCatchs > 1"
                v-tooltip.top-center="$t('common_words.erase')"
                class="btn-danger btn-simple btn-link custom-margin-actions"
                @click="removeRow(index)"
              >
                <em class="fa fa-times custom-size-fa-actions"></em>
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import MixinForm from 'src/mixins/forms/mixin-form';

export default {
  name: 'ScheduleTable',
  props: {
    form: Object,
    weekList: Array,
    activities: Array,
    farmLots: Array,
    farmLotsMultiple: Array,
    isPastWeekDisabled: Function,
    isCoveredAreaDisabled: Function,
  },
  mixins: [MixinForm],
  computed: {
    getMaxArea() {
      return (index) => {
        const lotId = this.form.lot[index];
        if (!lotId) return null;

        const lot = this.farmLots.find((l) => l.id === lotId);

        return lot ? Number(lot.area) : null;
      };
    },
  },
  data() {
    return {
      modelValidations: {
        area: (index) => ({
          required: this.form.custom[index],
          max: 6,
          min_value: 0,
          max_value: this.getMaxArea(index),
          decimal: 2,
        }),
      },
    };
  },
  methods: {
    handleInputChange(data) {
      this.$emit('input-change', data);
    },
    handleWeekSelection(index, week) {
      this.$emit('week-selection-change', index, week);
    },
    handleCustomSelection(index) {
      this.$emit('custom-selection-change', index);
    },
    clearWeekSelection(index) {
      this.$emit('clear-week-selection', index);
    },
    addScheduleRow() {
      this.$emit('add-row');
    },
    removeRow(index) {
      this.$emit('remove-row', index);
    },
  },
};
</script>

<style scoped>
.fixed-column-custom-th,
.fixed-column-activity-th,
.fixed-column-lot-th,
.fixed-column-covered-area-th,
.fixed-column-operations-th,
.fixed-column-custom-td,
.fixed-column-activity-td,
.fixed-column-lot-td,
.fixed-column-covered-area-td,
.fixed-column-operations-td {
  position: sticky;
  border-right: 1px solid;
  z-index: 3;
}

.fixed-column-custom-th,
.fixed-column-activity-th,
.fixed-column-lot-th,
.fixed-column-covered-area-th,
.fixed-column-operations-th {
  background-color: #898989;
}

.fixed-column-custom-td,
.fixed-column-activity-td,
.fixed-column-lot-td,
.fixed-column-covered-area-td,
.fixed-column-operations-td {
  background-color: #fff;
}

.fixed-column-custom-th,
.fixed-column-custom-td {
  left: 0;
}

.fixed-column-activity-th,
.fixed-column-activity-td {
  left: 110px;
  z-index: 2;
}

.fixed-column-lot-th,
.fixed-column-lot-td {
  left: 360px;
  z-index: 2;
}

.fixed-column-covered-area-th,
.fixed-column-covered-area-td {
  left: 560px;
  z-index: 2;
}

.fixed-column-operations-th,
.fixed-column-operations-td {
  right: 0;
  z-index: 2;
}
</style>
